import React from 'react'
import { Header } from './Header/Header'
import { Footer } from './Header/Footer'
import { WorkshopMenuItem } from './Models/workshopMenu'
import { WorkshopNav } from './WorkshopNav/WorkshopNav'
import { Language, Text } from './language'
import { Loader } from './Components/Loader'

import watermarkDesktop from './watermark-desktop-landscape.png'
import watermarkMobile from './watermark-mobile-portrait.png'

import './AppView.scss'
import classNames from 'classnames'

export type AppViewProps = React.PropsWithChildren<{
	workshopMenuItems: Array<WorkshopMenuItem>
	language: Language
	renderLandingImage: boolean
}> 

export function AppView(props: AppViewProps) {

	const landingImages = !props.renderLandingImage ? null : 
		<>
			<img className='landing-image desktop landscape' src={watermarkDesktop} width='100%' alt={Text[props.language].Farmland} />
			<img className='landing-image mobile portrait' src={watermarkMobile} width='100%' alt={Text[props.language].Farmland} />
		</>

	const mainContentClass = classNames('column', 'is-10', 'main-content', props.renderLandingImage && 'watermark-rendered')

	return (
		<div className='container pt-1'>
			<Header />
			{landingImages}
			<div className='columns'>
				<div className='column is-2'>
					<Loader isActive={props.workshopMenuItems.length == 0} />
					<WorkshopNav
						workshopMenuItems={props.workshopMenuItems}
						language={props.language}
					/>
				</div>
				<div className={mainContentClass}>
					{props.children}
				</div>
			</div>
			<Footer />
		</div>
	)
}

export default AppView